// One-click routine tidy-up for managers: clear old due dates on every routine, optionally mark everything up to now as caught up.
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Sparkles, Loader2 } from "lucide-react";
import { workspaceApi, emitTasksChanged } from "../_shared";

export default function RoutineTidy({ onDone }) {
  const [p, setP] = useState(null);
  const [open, setOpen] = useState(false);
  const [catchUp, setCatchUp] = useState(true);
  const [busy, setBusy] = useState(false);
  useEffect(() => { workspaceApi.tidyPreview().then(setP).catch(() => {}); }, [open]);
  const run = async () => {
    setBusy(true);
    try {
      const r = await workspaceApi.tidy(catchUp);
      setOpen(false); emitTasksChanged(); onDone?.();
      toast.success(`Routines tidied · ${r.changed} changes`, { duration: 15000, action: { label: "Undo", onClick: async () => { await workspaceApi.bulkUndo(r.batch_id); emitTasksChanged(); onDone?.(); toast("Tidy-up undone"); } } });
    } catch (e) { toast.error(e?.response?.data?.detail || "Tidy-up failed"); } finally { setBusy(false); }
  };
  return (
    <span className="relative ml-auto">
      <button onClick={() => setOpen((o) => !o)} className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-violet-400/50 bg-violet-500/15 text-violet-100 text-[12px]" data-testid="routine-tidy-open">
        <Sparkles className="w-3.5 h-3.5" />Tidy routines</button>
      {open && (
        <div className="absolute right-0 top-full mt-2 z-40 w-80 rounded-xl border border-white/10 bg-[#0b1522] p-3 shadow-2xl space-y-2.5" data-testid="routine-tidy-panel">
          <div className="text-[12.5px] text-white">{p ? `${p.routines} routines · ${p.with_due_date} still have a due date` : "Checking…"}</div>
          <p className="text-[11.5px] text-slate-400">Clears every routine's due date (routines run on their rhythm instead).</p>
          <label className="flex items-start gap-2 text-[12px] text-slate-200 cursor-pointer">
            <input type="checkbox" checked={catchUp} onChange={(e) => setCatchUp(e.target.checked)} className="mt-0.5" data-testid="routine-tidy-catchup" />
            Also mark everything up to now as caught up, so nobody starts behind
          </label>
          <div className="flex justify-end gap-2">
            <button onClick={() => setOpen(false)} className="px-3 py-1.5 text-[12px] text-slate-300">Cancel</button>
            <button onClick={run} disabled={busy || !p?.routines} className="px-3 py-1.5 rounded-lg bg-violet-500 text-white text-[12px] disabled:opacity-40 inline-flex items-center gap-1.5" data-testid="routine-tidy-run">
              {busy && <Loader2 className="w-3.5 h-3.5 animate-spin" />}Tidy now</button>
          </div>
        </div>
      )}
    </span>
  );
}
